import { Stack } from '@mui/material';
import React from 'react';
import { TrainingViewSeeAlsoBox } from 'views/lms/components/TrainingViewSeeAlsoBox';
import { TrainingViewSpecialistBox } from 'views/lms/components/TrainingViewSpecialistBox';
import { TrainingViewTopicBox } from 'views/lms/components/TrainingViewTopicBox';

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    trainingId: string;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TrainingViewRightPanel: React.FC<IProps> = ({ trainingId }) => {

    return (
        <Stack rowGap={5.5}>
            <TrainingViewSeeAlsoBox trainingId={trainingId} />
            <TrainingViewSpecialistBox trainingId={trainingId} />
            <TrainingViewTopicBox trainingId={trainingId} />
        </Stack>
    );
};
